import React, { useEffect, useRef, useState,useCallback } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import { Button, Select } from "@mantine/core";

import { InventoryMovementsTable } from "./InventoryMovementsTable";
import NavBar from "../Navigation bar/Navbar";
import moment from "moment";
import Backdrop from "../backdrop/backdrop";
import { toast } from "react-toastify";
import {
  fetchInventoryMovements,
  fetchInventoryMovementsExportAll,
  fetchInventoryMovementsExport_new,
  fetchPriceDetails,
} from "../../services/InventoryMovements.services";
import ExportToExcel from "../InventoryManagementExport/ExportToExcel";
import { warehouseNames } from "../../Configs/mysqlconfig";
import { warehouses,useWarehouseList } from '../../indexedDBUtility.js';
import {validateIsAdminUser,validateIsStockUser} from '../UserCredentials.js'

import {closingInventory} from './renderTableData/closingInventory.js'
import {closingInventoryTransactions} from './renderTableData/closingInventoryTransactions.js'
import {currentInventoryTransactions} from './renderTableData/currentInventoryTransactions.js'
import { use } from "react";



const modeToColumns = {
  "Closing Inventory":                 closingInventory,
  "Closing Inventory Transactions":    closingInventoryTransactions,
 "Current Inventory Transactions":    currentInventoryTransactions,
};

const yesterday = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return d;
};

const retrievedCityList = JSON.parse(sessionStorage.getItem('cityList') || '[]').map(city => city.trim());

const formatRetrievedCityList = retrievedCityList.map(city => {
 const warehouseFormatObj = { value: city, label: city }
 return warehouseFormatObj
})

const Header = styled.div`
  display: flex;
  height: 18vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 1rem;
`;

const PageTitle = styled.div`
  font-weight: bolder;
  font-size: 2rem;
  text-align: center;
`;

const DateTitle = styled.div`
  text-align: center;
`;
const DateSelector = styled(DatePicker)`
  margin-left: 1rem;
  margin-right: 1rem;
`;

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageContainer = styled.div`
  width: 100%;
`;

const TableContainer = styled.div`
  width: 100%;
  padding: 1rem;
  flex: 1;
`;

const WarehouseSelectContainer = styled.div`
  margin: 0 1rem;
  align-self: flex-end;
`;

const FetchDataButton = styled(Button)`
  margin-top: 1rem;
`;

const ButtonStyle = styled(Button)`
  margin-right: 1rem;
`;

const ExportBtnStyles = styled.div`
  margin-top: 1rem;
`;

// const warehouseList = [
//   { value: "All", label: "All" },
//   { value: "Goa", label: "Goa" },
//   { value: "Vashi", label: "Vashi" },
//   { value: "Mira Road", label: "Mira Road" },
//   { value: "Wadala", label: "Wadala" },
//   { value: "Bhiwandi", label: "Bhiwandi" },
// ];

// const mapWarehouseList = (names) => {
//   return names.map(name => ({
//     value: name,
//     label: name
//   }));
// };

// const warehouseList = mapWarehouseList(warehouseNames);





export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
  instance: { setFilter: setTableFilter } = {},
  categoryFilter,
  setCategoryFilter,
  subCategoryFilter,
  setSubCategoryFilter
}) {
  let opts;

  if (id === 'category' && filterValue) {
    opts = ['All', filterValue];
  } else {
    // 1) collect unique, non‐empty values
    const uniq = Array.from(
      new Set(
        preFilteredRows
          .map(r => r.values[id])
          .filter(v => v != null && v !== '')
      )
    );
    // 2) sort them A→Z
    uniq.sort((a, b) => String(a).localeCompare(String(b)));
    // 3) ensure "All" is first
    opts = ['All', ...uniq];
  }

  return (
    <select
      value={filterValue ?? 'All'}
      onChange={e => {
        const v = e.target.value;

        if (id === 'category') {
          if (setTableFilter) setTableFilter('sub_category', undefined);        
          window.dispatchEvent(
            new CustomEvent('categoryFilterChanged', { detail: v })
          );
        } else if (id === 'sub_category') {
          if (setTableFilter) setTableFilter('category', undefined);       
          window.dispatchEvent(
            new CustomEvent('subCategoryFilterChanged', { detail: v })
          );
        }

        setFilter(v === 'All' ? undefined : v);
      }}
    >
      {opts.map(opt => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  );
}


const isNumber = (item) => {
  return isNaN(Number(item)) ? 0 : Number(item);
};

export function getFooterSum(data, field) {
  if (!data.rows || data.rows.length === 0 || !field) {
    return 0;
  }

  let footerSum = data.rows.reduce((sum, row) => {
    return isNumber(row.values[field]) + Number(sum);
  }, 0);
  return footerSum.toFixed(1);
}

const InventoryMovementsDetails = ({ history }) => {

  // Default mode is "Closing Inventory"
  const [mode, setMode] = useState("Closing Inventory");
  const categoryFilterRef = useRef("All");
  const subCategoryFilterRef = useRef("All");
  const [selectedColumns,setSelectedColumns] = useState(modeToColumns[mode] || []);

  const [maxDate, setMaxDate] = useState(yesterday);

  useEffect(() => {
  warehouses
  .then(data => {
    console.log("Fetched Warehouses:", data);
    const allWarehouses = [
      { value: "All", label: "All" },
      ...data.map(obj => ({ value: obj.warehouse, label: obj.warehouse }))
    ];

    if(formatRetrievedCityList.length > 0){
      setWarehouseList(formatRetrievedCityList);
      warehouseListRef.current = formatRetrievedCityList;

    }
    else
    setWarehouseList(allWarehouses);
    warehouseListRef.current = allWarehouses;
    console.log("All warehouses:", allWarehouses);
  }
  )
  .catch(error => {
    console.error("Failed to fetch warehouses:", error);
  });
}, []);




useEffect(() => {
  if(mode==="Current Inventory Transactions"){
    setMaxDate(new Date());
    setDateRangeStart(new Date());
  }
  else{
    setMaxDate(yesterday);
    setDateRangeStart(yesterday)
  }

  if(modeToColumns[mode]){
  setSelectedColumns(modeToColumns[mode] || []);
  }
  
  // Reset filters using refs
  categoryFilterRef.current = "All";
  subCategoryFilterRef.current = "All";
  // Manually trigger filter update if needed
  setFilteredMultiSheets({});
},[mode]);

  
  const [tableData, setTableData] = useState([]);

  const [inventoryData, setInventoryData] = useState({});
  const inventoryDataRef = useRef({});

  const [filteredMultiSheets, setFilteredMultiSheets] = useState({});
  const [dateRangeStart, setDateRangeStart] = useState(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  });

  const [warehouseList, setWarehouseList] = useState([ { value: (retrievedCityList[0] || "All"), label: (retrievedCityList[0] || "All") } ])
  const warehouseListRef = useRef([ { value: (retrievedCityList[0] || "All"), label: (retrievedCityList[0] || "All") } ])

  const [warehouse, setWarehouse] = useState((retrievedCityList[0] || "All"));
  const selectedWarehouse = useRef(retrievedCityList[0] || "All")

  const handleWarehouseChange = (value) => {
    setWarehouse(value);  
    selectedWarehouse.current = value;
    setShouldCallAPI(true);
  }

  

  const ModeContainer = styled.div`
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  `;






  const [isLoading, setIsLoading] = useState(false);
  const [inventoryPriceDetails, setInventoryPriceDetails] = useState({});

  const greenColumnHeaderHighlight = "rgba(0,200,0,.6)";
  const redColumnHeaderHighlight = "rgba(200,0,0,.6)";


  const parentWarehouseAllowedColumns = [
  'item_id',
  'desc_brand',
  'category',
  'sub_category',
 
  'inventory_after_shipped',
   "closing_inventory","resultant_inventory_weight_closing","closing_inventory_value",
  'resultant_inventory',
  'last_day_closing_inventory',
  'resultant_inventory_weight',
  'inventory_value',
  'grn_qty',
  'stock_transfer',
  'balance_qty',
  'converted_stock',
  "parent_in_production",
  "child_in_production",
  'shipped_qty',
  'delivered_qty',
  'sample_qty',
  'returned_qty',
  'customer_returns',
  'shipped_to_child',
  'return_from_child',
  'dumped_qty',
  'stock_correction',
  'stock_discrepancy',
  'stock_movement',
  'active_status'
]


const childWarehouseAllowedColumns = [
  'item_id',
  'desc_brand',
  'category',
  'sub_category',
  
  'inventory_after_shipped',
   "closing_inventory","resultant_inventory_weight_closing","closing_inventory_value",
  'resultant_inventory',
  'last_day_closing_inventory',
  'resultant_inventory_weight',
  'inventory_value',
  // "parent_in_production",
  // "child_in_production",
  'child_grn',
  'shipped_qty',
  'delivered_qty',
  'returned_qty',
  'customer_returns',
  'shipped_to_parent',
  'stock_correction',
  'stock_discrepancy',
  'stock_movement',
  'active_status'
]


const goaWarehouseAllowedColumns = [
  'item_id',
  'desc_brand',
  'category',
  'sub_category',
  
  'inventory_after_shipped',
   "closing_inventory","resultant_inventory_weight_closing","closing_inventory_value",
  'resultant_inventory',
  'last_day_closing_inventory',
  'resultant_inventory_weight',
  'inventory_value',
  'stock_movement',
  'shipped_qty',
  //  'converted_stock',
  //  'stock_transfer',
    "parent_in_production",
    "child_in_production",
  'delivered_qty',
  'returned_qty',
  'customer_returns',
  'stock_correction',
  'stock_discrepancy',
  'active_status'
]


// const allWarehouseAllowedColumns = [
//   'item_id',
//   'desc_brand',
//   'category',
//   'sub_category',
//   'last_day_closing_inventory',
//   'inventory_after_shipped',
//   'resultant_inventory',
//   'resultant_inventory_weight',
//   'inventory_value',
//   'grn_qty',
//   'child_grn',
//   'stock_transfer',
//   'converted_stock',
//   'shipped_qty',
//   'delivered_qty',
//   'sample_qty',
//   'returned_qty',
//   'customer_returns',
//   'shipped_to_parent',
//   'shipped_to_child',
//   'return_from_child',
//   'dumped_qty',
//   'stock_correction',
//   'stock_discrepancy',
//   'stock_movement',
//   'intransit_transfer',
//   'intransit_return',
//   'active_status'
// ]

function pickColumns(selectedCols, allowedList) {
  return allowedList
    .map(accessor => selectedCols.find(col => col.accessor === accessor))
    .filter(col => col !== undefined);
}

const parentWarehouseColumns = pickColumns(
  selectedColumns,
  parentWarehouseAllowedColumns
);

const childWarehouseColumns = pickColumns(
  selectedColumns,
  childWarehouseAllowedColumns
);


const goaWarehouseColumns = pickColumns(
  selectedColumns,
  goaWarehouseAllowedColumns
);

// const allWarehouseColumns = pickColumns(
//   selectedColumns,
//   allWarehouseAllowedColumns
// );

const allWarehouseColumns = selectedColumns

  



  const getAllInventoryMovementsExport = async () => {
    // Start loading
    setIsLoading(true);
    try {
      // Make both API calls concurrently
      const [exportResult, priceResult] = await Promise.all([
        fetchFunc(
          moment(dateRangeStart).format("YYYY-MM-DD"),
          warehouse
        ),
        fetchPriceDetails(),
      ]);
  
      console.log("Fetched export data");
  
      // Extract arrays from the API responses
      const inventoryExportData = exportResult.data; // Should be an array of items
      const itemPriceDetails = priceResult.data; // Object keyed by item_id
      setInventoryPriceDetails(itemPriceDetails);
  
      // Initialize the grouping object based on the known warehouse list.
      const inventoryByWarehouse = {};

      warehouseListRef.current.forEach(item => {
        // if your list items are either strings or { value, label } objects
        const key = typeof item === "string" ? item : item.value;
        inventoryByWarehouse[key] = [];
        });


      let normalisedWarehouses = []
      if(warehouseListRef.current && warehouseListRef.current.length >0)
      {
          normalisedWarehouses = warehouseListRef.current.map(w =>
            String(w.value)?.toLowerCase()?.trim()
          );
        }
        
      
      // inventoryByWarehouse["All"] = [];
  
      // Process each item from the export data
      inventoryExportData.forEach((item) => {
        if (item.warehouse && item.warehouse !== "") {
          // Compose the description and brand field
          item.desc_brand = `${item.item_disc || ""} -- ${item.brand || ""}`;
          // Get item price details – landing cost
          const item_price = itemPriceDetails[item.item_id]?.landing_cost || "N/A";
          if (item_price !== "N/A") {
            // Multiply the resultant_inventory_weight by the item price.
            // Note: If resultant_inventory_weight comes as a string, multiplication works if the string is numeric.
            item.inventory_value = Number(item.resultant_inventory_weight * item_price).toFixed(2);
            item.closing_inventory_value = Number(
              item.resultant_inventory_weight_closing * item_price
            ).toFixed(2);
          }
          else{
            item.inventory_value  = 0
          }
          
          // console.log("Normalised Warehouses:", normalisedWarehouses);

          // If the warehouse exists in our grouping object, push the item there.
          if(item?.warehouse?.toLowerCase() === "all" && normalisedWarehouses.includes(item.warehouse?.toLowerCase()?.trim())){
            inventoryByWarehouse["All"].push(item);   
          }
          else if (inventoryByWarehouse.hasOwnProperty(item.warehouse)  && normalisedWarehouses.includes(item.warehouse?.toLowerCase()?.trim())) {
            console.log("Pushing item into warehouse:", item.warehouse);
            inventoryByWarehouse[item.warehouse].push(item);
          }

          // if(mode !== "Current Inventory Transactions")
          //   {

          //   if(item?.warehouse?.toLowerCase() !== "all"){
          //     inventoryByWarehouse["All"].push(item);
          //   }
          // } // it will fetch from new API and it will not have "all" in warehouse
          // else if(mode === "Current Inventory Transactions" && 
          //   (new Date()).setDate(new Date().getDate() - 7) >= new Date(dateRangeStart) )
          //   {
          //     if(item?.warehouse?.toLowerCase() !== "all"){
          //       inventoryByWarehouse["All"].push(item);
          //     }
          //   }
          
          // else{
          //   if(item?.warehouse?.toLowerCase() === "all"){
          //     inventoryByWarehouse["All"].push(item);
          //   }
          // }

          
        }
      });
  
      console.log("Check export data (grouped by warehouse):", inventoryByWarehouse);
      setIsLoading(false);
  
      // Update state with the grouped inventory data
      setInventoryData(inventoryByWarehouse);
      inventoryDataRef.current = inventoryByWarehouse;
    } catch (err) {
      toast(`Error: ${err}`, { type: toast.TYPE.ERROR });
      setIsLoading(false);
    }
  }



  function getInventoryMovementsTableData() {
    const inventoryMovementsData = [...inventoryData[warehouse].map(item => ({ ...item }))];
    const itemPriceDetails = inventoryPriceDetails;

    inventoryMovementsData.forEach((item) => {
      const item_price = itemPriceDetails[item.item_id]?.landing_cost || "N/A";
      item.shipped_qty = parseFloat(item.shipped_qty || 0).toFixed(2);
      item.delivered_qty = parseFloat(item.delivered_qty || 0).toFixed(2);
      item.customer_returns = parseFloat(item.customer_returns || 0).toFixed(2);
      item.stock_correction = parseFloat(item.stock_correction || 0).toFixed(2);
      item.shipped_to_parent = parseFloat(item.shipped_to_parent || 0).toFixed(
        2
      );
      item.balance_qty_kgs = parseFloat(item.balance_qty_kgs || 0).toFixed(
        2
      );
      item.shipped_to_child = parseFloat(item.shipped_to_child || 0).toFixed(2);
      item.returned_qty = parseFloat(item.returned_qty || 0).toFixed(2);
      item.return_from_child = parseFloat(item.return_from_child || 0).toFixed(
        2
      );
      item.dumped_qty = parseFloat(item.dumped_qty || 0).toFixed(2);
      item.grn_qty = parseFloat(item.grn_qty || 0).toFixed(2);
      item.child_grn = parseFloat(item.child_grn || 0).toFixed(2);
      item.stock_take = parseFloat(item.stock_take || 0).toFixed(2);
      item.bag_weight_loss = parseFloat(item.bag_weight_loss || 0).toFixed(2);
      item.stock_transfer = parseFloat(item.stock_transfer || 0) !== 0 ? parseFloat(item.stock_transfer).toFixed(2) 
                    :(parseFloat(item.reverse_converted_stock || 0) !== 0 ? parseFloat(item.reverse_converted_stock).toFixed(2) : 0);
      
      const converted_stock = parseFloat(item.converted_stock || 0);
      const reverse_stock_transfer = parseFloat(item.reverse_stock_transfer || 0);
      if (converted_stock !== 0 && reverse_stock_transfer !== 0) {
        item.converted_stock = (converted_stock + reverse_stock_transfer).toFixed(2);
      } else if (converted_stock !== 0) {
        item.converted_stock = converted_stock.toFixed(2);
      } else if (reverse_stock_transfer !== 0) {
        item.converted_stock = reverse_stock_transfer.toFixed(2);
      } else {
        item.converted_stock = 0;
      }
      
      item.wastage = parseFloat(item.wastage || 0).toFixed(2);
      item.sample_qty = parseFloat(item.sample_qty || 0).toFixed(2);
      item.inventory_value = "N/A";

      item.resultant_inventory = parseFloat(
        item.resultant_inventory || 0
      ).toFixed(2);
      item.last_day_closing_inventory = parseFloat(
        item.last_day_closing_inventory || 0
      ).toFixed(2);
      item.inventory_after_shipped = parseFloat(
        item.inventory_after_shipped || 0
      ).toFixed(2);
      item.resultant_inventory = parseFloat(item.resultant_inventory).toFixed(
        2
      );
      item.resultant_inventory_weight = parseFloat(
        item.resultant_inventory_weight
      ).toFixed(2);

      if (item_price !== "N/A") {
        item.inventory_value = parseFloat(
          item.resultant_inventory_weight * item_price
        ).toFixed(2);
      }

      item.desc_brand = `${item.item_disc || ""} -- ${item.brand || ""}`;
      item.intransit_transfer = parseFloat(
        item.intransit_transfer || 0
      ).toFixed(2);
      item.intransit_return = parseFloat(item.intransit_return || 0).toFixed(2);
    });
    
    setTableData(inventoryMovementsData);
    console.log("Table data:", inventoryMovementsData);
  }

  useEffect(() => {
    if (
           warehouse &&
           inventoryData &&
           inventoryData[warehouse]
         ) {
           
           if (inventoryData[warehouse].length > 0) {
             // has rows → build the table
             getInventoryMovementsTableData();
           } else {
             // no rows → clear the table so your UI shows "No data available"
             setTableData([]);
            
           }
         }
  }, [warehouse, inventoryData]);


  var fetchFunc;
  switch (mode) {
    case "Closing Inventory":
      fetchFunc = fetchInventoryMovementsExport_new;
      break;
    case "Closing Inventory Transactions":
      fetchFunc = fetchInventoryMovementsExport_new;
      break;
    case "Current Inventory Transactions":
      fetchFunc = ((new Date()).setDate(new Date().getDate() - 7) < new Date(dateRangeStart)) ? fetchInventoryMovementsExportAll : fetchInventoryMovementsExport_new;
      break;
    default:
      fetchFunc = fetchInventoryMovementsExport_new;
    }


  const [shouldCallAPI, setShouldCallAPI] = useState(false);
  const modeRef = useRef("not available");
  const dateRangeStartRef = useRef("not available");

// combining the state changes trigger and making ref for unecessary re-renders on the same date click
 useEffect(() => {  

  if( modeRef.current !== mode || new Date(dateRangeStartRef.current).toISOString().split("T")[0] !== new Date(dateRangeStart).toISOString().split("T")[0]  ){
    setShouldCallAPI(true);
  }

    modeRef.current = mode;
    dateRangeStartRef.current = dateRangeStart;

 }, [mode, dateRangeStart]);



 

  useEffect(() => {
    if (dateRangeStart && warehouseList.length > 0) {
      if(shouldCallAPI){

        categoryFilterRef.current = "All";
        subCategoryFilterRef.current = "All";

        getAllInventoryMovementsExport();
        
    
        setShouldCallAPI(false);
            
      }

    }
  }, [warehouseList,warehouse,shouldCallAPI]);

  const [,,,,,,,,,DC_list] = useWarehouseList();

    const applyFilterOntableDataExport = (tableData) => {
    const parsed = JSON.parse(sessionStorage.getItem("cityList") || "[]");
    const cityList = parsed.map(item => item?.toLowerCase().trim())

    // Use refs for filters
    const categoryFilter = categoryFilterRef.current;
    const subCategoryFilter = subCategoryFilterRef.current;
    // console.log({categoryFilter})
    // console.log({subCategoryFilter})

      return tableData.filter((item) => {
      const categoryMatch =
        categoryFilter ===  item.category;
      const subCategoryMatch =
          subCategoryFilter === item.sub_category;


      if(cityList.length == 0 && categoryFilter === "All" && subCategoryFilter === "All")
      {
        // All export
        return true
      }
      else if ( cityList.length > 0 && categoryFilter === "All" && subCategoryFilter === "All"){
        // Only warehouse level export
        return cityList.includes(item.warehouse?.toLowerCase()?.trim()); 
      }
      else if ( cityList.length > 0 && categoryFilter !== "All" && subCategoryFilter !== "All"){
        // Warehouse & category & subcategory export
        return cityList.includes(item.warehouse?.toLowerCase()?.trim()) && categoryMatch && subCategoryMatch; 
      }
      else if ( cityList.length > 0 && categoryFilter !== "All" && subCategoryFilter === "All"){
        // Warehosue & category export
        return cityList.includes(item.warehouse?.toLowerCase()?.trim()) && categoryMatch; 
      }
      else if ( cityList.length > 0 && categoryFilter === "All" && subCategoryFilter !== "All"){
        // Warehouse & subcategory export
        return cityList.includes(item.warehouse?.toLowerCase()?.trim()) && subCategoryMatch; 
      }
      else if ( cityList.length == 0 &&  categoryFilter !== "All" && subCategoryFilter !== "All"){
        // Only category & subcategory export
        return categoryMatch && subCategoryMatch; 
      }
      else if ( cityList.length == 0 &&  categoryFilter !== "All" && subCategoryFilter === "All"){
        // Only category export
        return categoryMatch; 
      }
      else if ( cityList.length == 0 &&  subCategoryFilter !== "All" && categoryFilter === "All"){
        // Only subcategory export
        return subCategoryMatch; 
      }
      // Additional Handling
      else if ( cityList.length > 0 && categoryFilter !== "All"){
        // Warehouse & category export
        return categoryMatch && cityList.includes(item.warehouse?.toLowerCase()?.trim());
      }
     else if ( cityList.length > 0 && subCategoryFilter !== "All"){
      // Warehouse & subcategory export
        return cityList.includes(item.warehouse?.toLowerCase()?.trim()) && subCategoryMatch;
      }

    
    });
  }

useEffect(() => {

  const handler = () => {
    // Use refs for filters
    if (warehouse !== "All") {
      // only one sheet
      const filtered = applyFilterOntableDataExport(
        inventoryData[warehouse] || []
      );
      setFilteredMultiSheets({ [warehouse]: filtered });
    } else {
      const out = {};
      Object.keys(inventoryData).forEach(wh => {
        out[wh] = applyFilterOntableDataExport(inventoryData[wh]);
      });
      setFilteredMultiSheets(out);
    }
  };

   const onCat = e => {
    categoryFilterRef.current = e.detail;
    handler()
  };
  const onSubCat = e => {
    subCategoryFilterRef.current = e.detail;
    console.log("Subcategory filter changed:", e.detail);
    handler()
  };
  
  
  handler()

  window.addEventListener("categoryFilterChanged", onCat);
  window.addEventListener("subCategoryFilterChanged", onSubCat);


  return () => {
    window.removeEventListener("categoryFilterChanged", onCat);
    window.removeEventListener("subCategoryFilterChanged", onSubCat);
  };
  
}, [inventoryData]);



  return (
    <>
      <NavBar />
      <br />
      <br />
      <br />
      <PageContainer>
        <Header>
          <PageTitle> Inventory</PageTitle>
          <DateContainer>
            <DateTitle>Select Date</DateTitle>
            <DateSelector
              selected={dateRangeStart}
              onChange={setDateRangeStart}
              minDate={(mode === "Current Inventory Transactions") ? new Date().setDate(new Date().getDate() - 7) : new Date("1998-01-01")}
              maxDate={   
                new Date(maxDate)
              }
            />
          </DateContainer>
          <WarehouseSelectContainer>
            <Select
              label="Warehouse"
              placeholder="Select"
              value={warehouse}
              data={warehouseList}
              onChange={handleWarehouseChange}
            />
          </WarehouseSelectContainer>
          {validateIsAdminUser(JSON.parse(sessionStorage.getItem(`user`))[0].email) && <ButtonStyle
            size="sm"
            color="blue"
            onClick={() => {
              history.push("/inventory-reports");
            }}
          >
            Reports
          </ButtonStyle>}


           
          <ExportBtnStyles>
            { 
              ( validateIsStockUser(JSON.parse(sessionStorage.getItem(`user`))[0].email) && mode!=="Current Inventory Transactions") 
              ?

               <ExportToExcel


              sheet1={() => applyFilterOntableDataExport(tableData)}
              multiSheets={selectedWarehouse.current === "All" ? filteredMultiSheets : null}
              
              filename={"Inventory_movements"}
              sheet1Headers={
                
                 DC_list.includes(warehouse)
                  ? parentWarehouseColumns  
                  : warehouse === "All"
                  ? allWarehouseColumns
                  : warehouse === "Goa"
                  ? goaWarehouseColumns
                  : childWarehouseColumns
              }
              sheet1Name={warehouse}
            />

          : 
            ["admin","finance","commercial","financemis"]
            .includes(
              JSON.parse(sessionStorage.getItem("user") || "[]")
                [0]?.user_type
                ?.toLowerCase()
                .trim() || ""
            )     
                ?
             <ExportToExcel


              sheet1={() => applyFilterOntableDataExport(tableData)}
              multiSheets={selectedWarehouse.current === "All" ? filteredMultiSheets : null}
              
              filename={"Inventory_movements"}
              sheet1Headers={
                
                 DC_list.includes(warehouse)
                  ? parentWarehouseColumns  
                  : warehouse === "All"
                  ? allWarehouseColumns
                  : warehouse === "Goa"
                  ? goaWarehouseColumns
                  : childWarehouseColumns
              }
              sheet1Name={warehouse}
            />
              :
          <Button
          disabled={true}
          >Export</Button>
        
        } 
        </ExportBtnStyles>
          
          <ModeContainer>
          <Select
            label="Select Mode"
            value={mode}
         data={[
              { value: "Closing Inventory", label: "Closing Inventory" },
              { value: "Closing Inventory Transactions", label: "Closing Inventory Transactions" },
              validateIsStockUser(JSON.parse(sessionStorage.getItem(`user`))[0].email) || validateIsAdminUser(JSON.parse(sessionStorage.getItem(`user`))[0].email)
                ? { value: "Current Inventory Transactions", label: "Current Inventory Transactions" }
                : null,
            ].filter(Boolean)} 
            onChange={(value) => setMode(value)}
          />
        </ModeContainer>

        </Header>
        <TableContainer>
            {tableData.length > 0 ? (
              <InventoryMovementsTable
                tableData={tableData}
                parentWarehouseColumns={parentWarehouseColumns}
                childWarehouseColumns={childWarehouseColumns}
                goaWarehouseColumns={goaWarehouseColumns}
                allWarehouseColumns={allWarehouseColumns}
                warehouse={warehouse}
                history={history}
                // categoryFilter={categoryFilterRef.current}
                // setCategoryFilter={(val) => { categoryFilterRef.current = val; setFilteredMultiSheets({}); }}
                // subCategoryFilter={subCategoryFilterRef.current}
                // setSubCategoryFilter={(val) => { subCategoryFilterRef.current = val; setFilteredMultiSheets({}); }}
              />
            ) : (
              <div style={{ textAlign: "center", padding: "2rem", color: "#666" }}>
                No data available
              </div>
            )}
          </TableContainer>
      </PageContainer>
      {isLoading ? <Backdrop parentLoadStatus={isLoading} /> : null}
    </>
  );
};

export default InventoryMovementsDetails;
